import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

/** True for /bids and anything under it — the URL is the only workspace source. */
export const isBidPath = (pathname) =>
  pathname === '/bids' || pathname.startsWith('/bids/');

/**
 * The current workspace (ticket #295): { type, id, record }.
 * type is 'bid' on any /bids path and 'project' everywhere else; id / record
 * are that workspace's selected bid or project (null when none is selected).
 * Pages that work in both workspaces read their owner from here.
 */
export function useWorkspace() {
  const { pathname } = useLocation();
  const project = useSelector((state) => state.project.selectedProject);
  const bid = useSelector((state) => state.bid.selectedBid);

  return isBidPath(pathname)
    ? { type: 'bid', id: bid?.id ?? null, record: bid }
    : { type: 'project', id: project?.id ?? null, record: project };
}

export default useWorkspace;
